// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2UOG5","label":"Radio_label__smsKE","checkMark":"Radio_checkMark__1M-d6","disabled":"Radio_disabled__3IlFr"};